<mat-accordion class="custom-accordion">
  <mat-expansion-panel *ngFor="let item of items" #panel hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title class="item-title">
        {{ item.header }}
      </mat-panel-title>
      <mat-panel-description>
        <mat-icon
          *ngIf="!panel.expanded"
          class="icon-circle collapsible-icon plus-icon"
          >add</mat-icon
        >
        <mat-icon
          *ngIf="panel.expanded"
          class="icon-circle collapsible-icon minus-icon"
          >remove</mat-icon
        >
      </mat-panel-description>
    </mat-expansion-panel-header>
    <ng-container *ngFor="let description of item.subItems">
      <app-flip-item-summary
        [variant]="'score-text'"
        [number]="description.number"
        [description]="description.content"
        [score]="description.score"
      ></app-flip-item-summary>
    </ng-container>
  </mat-expansion-panel>
</mat-accordion>
